export default __webpack_public_path__ + "static/media/Bhopal-Pachmari-Package.25dfc495.jpg";